import React from 'react';
import { motion } from 'framer-motion';
const recipes = [{
  name: 'Pan Francés',
  image: 'https://cdn.magicpatterns.com/uploads/5pdoVLSZDC7qrvyPEXQEK5/2cfdf5c1-5e41-40c7-8f00-92e68a182df7.jpg'
}, {
  name: 'Pan de Jamón',
  image: 'https://cdn.magicpatterns.com/uploads/ck87J42jScURg9GctLTept/F4B53A11-BB33-4497-A678-66F779714BE4.jpg'
}, {
  name: 'Golfeados',
  image: 'https://cdn.magicpatterns.com/uploads/9NZMzkVS6TE8b9oSRRmr61/IMG_3086.jpg'
}, {
  name: 'Pan de Guayaba',
  image: 'https://cdn.magicpatterns.com/uploads/14Y2ZvToMZSGBEGLbxKgFV/pan_guayaba.jpg'
}, {
  name: 'Quesadillas Artesanales',
  image: 'https://cdn.magicpatterns.com/uploads/qqSqtFiLBafTXzgFMDLhRp/IMG_3069.jpg'
}, {
  name: 'Pan Dulce / Pinitas',
  image: 'https://cdn.magicpatterns.com/uploads/vZQHsvhqXBSjwbWcERWaaw/IMG_2791.jpg'
}];
export function RecipeShowcase() {
  return <section id="recetas" className="py-24 bg-cream" data-id="element-199">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-201">
          <h2 className="text-4xl md:text-5xl font-bold text-espresso mb-6" data-id="element-202">
            Estos son algunos de lo que vas a aprender
          </h2>
          <p className="text-lg text-espresso/70 max-w-2xl mx-auto" data-id="element-203">
            Recetas emblemáticas, detalladas paso a paso, con fotografías que te
            guiarán hacia el resultado perfecto.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8" data-id="element-204">
          {recipes.map((recipe, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="group relative overflow-hidden bg-warm-white shadow-sm hover:shadow-xl transition-all duration-500" data-id="element-205">
              <div className="aspect-square overflow-hidden" data-id="element-206">
                <img src={recipe.image} alt={recipe.name} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-207" />
              </div>
              <div className="p-4 text-center border-t border-beige" data-id="element-208">
                <h3 className="font-serif text-lg font-medium text-espresso" data-id="element-209">
                  {recipe.name}
                </h3>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-16 text-center" data-id="element-210">
          <a href="#comprar" className="inline-block bg-espresso text-cream px-10 py-4 font-medium tracking-wide hover:bg-terracotta transition-colors duration-300" data-id="element-211">
            Obtener todas las recetas
          </a>
        </motion.div>
      </div>
    </section>;
}